import type { CourseID } from '@/models/ids';
import type { CurrencyCent } from '@/models/types';

export interface FeatureConfig {
  coreRecommendations: boolean;
  coreRecommendationStrikeLimit: CurrencyCent | null;

  earningRecommendations: boolean;
  earningRecommendationStrikeLimit: CurrencyCent | null;

  swingTradeRecommendations: boolean;
  swingTradeRecommendationPriceLimit: CurrencyCent | null;

  longTermRecommendations: boolean;
  longTermRecommendationPriceLimit: CurrencyCent | null;

  boostRecommendations: boolean;
  communityMember: boolean;

  chatbot: boolean;
  videoChatbot: boolean;
  journal: boolean;
  dayTrading: boolean;
  optionScreener: boolean;
  videoSearch: boolean;

  courses: Record<CourseID, boolean>;
  allCourses: boolean;
}

export type FeatureConfigKey = keyof Omit<FeatureConfig, 'coreRecommendationStrikeLimit'|'earningRecommendationStrikeLimit'|'swingTradeRecommendationPriceLimit'|'longTermRecommendationPriceLimit'|'courses'>;

export function isEmptyFeatureConfig(fc: FeatureConfig): boolean {
  if (fc.coreRecommendations) return false;
  if (fc.earningRecommendations) return false;
  if (fc.swingTradeRecommendations) return false;
  if (fc.longTermRecommendations) return false;
  if (fc.boostRecommendations) return false;

  if (fc.communityMember) return false;
  if (fc.chatbot) return false;
  if (fc.videoChatbot) return false;
  if (fc.journal) return false;
  if (fc.dayTrading) return false;
  if (fc.optionScreener) return false;
  if (fc.videoSearch) return false;

  if (Object.values(fc.courses).some(v => v)) return false;

  if (fc.allCourses) return false;

  return true;
}